import React from "react";
import PropTypes from "prop-types";

import Modal from "../../Modal";
import List from "./List";

class Templates extends React.Component {
  render() {
    const {
      templates,
      show,
      onClose,
      onShowNew,
      onDelete,
      onEdit
    } = this.props;

    return (
      <Modal title="Templates" visible={show} onClose={onClose}>
        <div>
          <div>
            <List data={templates} onDelete={onDelete} onEdit={onEdit} />
          </div>

          <button
            key="button"
            type="button"
            className="btn btn-pink btn-block btn-raised"
            onClick={onShowNew}
          >
            NEW TEMPLATE
          </button>
        </div>
      </Modal>
    );
  }
}

Templates.propTypes = {
  templates: PropTypes.array,
  show: PropTypes.bool,
  onClose: PropTypes.func,
  onShowNew: PropTypes.func,
  onDelete: PropTypes.func,
  onEdit: PropTypes.func
};

Templates.defaultProps = {
  show: false
};

export default Templates;
